const files = require.context('./modules', true, /\.js$/)

const modules = files.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = files(modulePath)
  modules[moduleName] = value
  return modules
}, {})

export default {
  install (Vue) {
    Vue.$api = modules
    Object.defineProperties(Vue.prototype, {
      $api: {
        get: function get () {
          return modules
        }
      }
    })
  }
}

export { modules }
